import dayjs, { Dayjs } from "dayjs";
import { i18n } from "../main";

export function formatDuration(value: string) {
  if (!value) {
    return null;
  }

  const d = dayjs.duration(value);
  const years = d.years();
  const months = d.months();
  const weeks = d.weeks();
  const days = d.days();
  const hours = d.hours();
  const minutes = d.minutes();
  const seconds = d.seconds();
  let formatedDays = "";
  let formatedMinutes = "";
  let formatedSeconds = "";
  let formatedHours = "";
  let formatedWeeks = "";
  let formatedYears = "";
  let formatedMonths = "";
  let result = "";
  if (years > 0) {
    formatedYears = `${years} ${i18n.global.t("years", years)}`;
  }
  if (months > 0) {
    formatedMonths = `${months} ${i18n.global.t("months", months)}`;
  }
  if (weeks > 0) {
    formatedWeeks = `${weeks} ${i18n.global.t("weeks", weeks)}`;
  }
  if (days > 0) {
    formatedDays = `${days} ${i18n.global.t("days", days)}`;
  }
  if (hours > 0) {
    formatedHours = `${hours} ${i18n.global.t("hours", hours)}`;
  }
  if (minutes > 0) {
    formatedMinutes = `${minutes} ${i18n.global.t("minutes", minutes)}`;
  }
  if (seconds > 0) {
    formatedSeconds = `${seconds} ${i18n.global.t("seconds", seconds)}`;
  }
  result = [
    formatedYears,
    formatedMonths,
    formatedWeeks,
    formatedDays,
    formatedHours,
    formatedMinutes,
    formatedSeconds,
  ]
    .filter((item) => item !== "")
    .join(", ");
  return result.trim();
}

export default function formatDate(
  date: string | Date | Dayjs | null | undefined,
) {
  if (!date) {
    return "n/a";
  }
  const mdate = dayjs(date);
  return mdate.format("DD.MM.YYYY");
}

export function formatDateMonth(
  date: string | Date | Dayjs | null | undefined,
) {
  if (!date) {
    return "n/a";
  }
  const mdate = dayjs(date);
  return mdate.format("MM.YYYY");
}

export function formatDateTime(date: string | Date | Dayjs | null | undefined) {
  if (!date) {
    return "n/a";
  }
  const mdate = dayjs(date);
  return mdate.format("DD.MM.YYYY HH:mm");
}
